var __vue_script__, __vue_template__
require("-!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-427556e7&file=DataBlock.vue!sass-loader?sourceMap!./../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./DataBlock.vue")
__vue_script__ = require("-!babel!eslint!./../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./DataBlock.vue")
__vue_template__ = require("-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./DataBlock.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "D:\\xampp\\htdocs\\projects\\resume\\src\\components\\DataBlock.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DataBlock.vue
 ** module id = 235
 ** module chunks = 0
 **/